import { Col, Form } from 'react-bootstrap'
import PropTypes from 'prop-types';

/**
 * این کامپوننت برای نمایش اینپوت سویچ است
 */
export default function Switchrs({ checke, name, label, handelValue, disabled ,defaultChecked,onCheck}) {
  const handelactive = (event) => {
    const value = event.target.checked;
    handelValue(name, value);
  };

  return (
    <Col className="d-flex align-items-center">
      {/* <div className="custom-control custom-switch">
                <label title="" htmlFor={name} className="custom-control-label">{label}</label>
                <input type="checkbox" id={name} checked={checke} onChange={handelactive} className="custom-control-input" />
            </div> */}

      <Form.Check
        type="switch"
        id={name}
        label={label}
        checked={checke}
        disabled={disabled}
        defaultChecked={defaultChecked}
        onChange={handelactive}
        style={{ direction: "rtl" }}
      />
    </Col>
  );
}
Switchrs.propTypes = {
    /**لیبل اینپوت است */
    label: PropTypes.string,
    /**برای ارسال مقدار اولیه برای اینپوت است */
    checke: PropTypes.bool,
    /** مقدار هلدر اینپوت است */
    Placeholder: PropTypes.string,
    /** نام اینپوت است */
    name: PropTypes.string,
    /** ارسال مقدار اینپوت به بالا است */
    handelValue: PropTypes.func
};